import React from "react";
import "../style/exploreevent.css";
import calendarImg from "../parm_assets/parm_calendar.jpeg";
import infoIcon from "../parm_assets/tree_icons.png";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


const EventsPage = () => {
  const events = [
    {
      title: "INTAC 2026 SEBERANG PERAI",
      date: "22 -24 SEPTEMBER 2026",
      more: "/intac2026-parm",
    },
    {
      title: "24th ARBORIST CERTIFICATION PROGRAMME",
      date: "04 - 13 MAY 2026",
      more: "/eventDetailPage"
    },
    {
      title: "Tree Identification Workshop",
      date: "31 MARCH 2025",
    },
  ];

  return (
    <section className="explore-events-section">
      <div className="explore-events-content">
        <div className="explore-events-text">
          <p className="explore-subheading">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            OUR PROGRAMS & EVENTS</p>
          <h2 className="explore-heading">
            Exploring PArM Events <br /> Every Years
          </h2>

          <div className="explore-event-list">
            {events.map((event, index) => (
              <div className="explore-event-card" key={index}>
                <div className="explore-event-info">
                  <h3>{event.title}</h3>
                  <p>{event.date}</p>
                </div>
                <a href={event.more} className="explore-btn-new-page">
                <button className="explore-arrow-btn">➜</button>
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="explore-events-image">
          <a href="/events" className="explore-btn-new-page">
          <button className="all-events-btn">All Events ➜</button>
          </a>
          <Zoom>
          <img src={calendarImg} alt="Calendar of Events" />
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default EventsPage;
